<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="mt-4 mb-4">
          <h2><strong class="courier">challenges()</strong></h2>
          <em class="monaco small">have a nice coding~</em>
        </div>
        <Final1 />
        <Final2 />
        <Final3 />
        <latihan-final-1 />
        <latihan-final-2 />
        <babak-junior-1 />
        <babak-junior-2 />
        <!-- <div class="card text-white text-left mb-5">
          <div class="maskot">
            <img src="~@/assets/img/maskot.png" class="maskot-img" alt="maskot">
          </div>
          <div class="card-body monaco pt-5">
            See you in the next event 👋🏻
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Final1 from '../components/Final1.vue';
import Final2 from '../components/Final2.vue';
import Final3 from '../components/Final3.vue';
import LatihanFinal1 from '../components/LatihanFinal1.vue';
import LatihanFinal2 from '../components/LatihanFinal2.vue';
import BabakJunior1 from '../components/BabakJunior1.vue';
import BabakJunior2 from '../components/BabakJunior2.vue';

export default {
  components: {
    Final1,
    Final2,
    Final3,
    LatihanFinal1,
    LatihanFinal2,
    BabakJunior1,
    BabakJunior2,
  },
};
</script>
